"use client"

import React from "react"

import { Button, Menu, MenuItem, Box } from "@mui/material"
import LanguageIcon from "@mui/icons-material/Language"
import { useLanguage } from "../../../context/LanguageContext"

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLanguageChange = (lang: "es" | "en") => {
    setLanguage(lang)
    handleClose()
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
      <Button
        onClick={handleClick}
        startIcon={<LanguageIcon />}
        sx={{
          color: "#666666",
          textTransform: "none",
          fontSize: "14px",
          "&:hover": {
            backgroundColor: "transparent",
            textDecoration: "underline",
          },
        }}
      >
        {language === "es" ? "Español" : "English"}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "4px",
          },
        }}
      >
        <MenuItem
          onClick={() => handleLanguageChange("es")}
          selected={language === "es"}
          sx={{
            fontSize: "14px",
            minWidth: "120px",
            "&.Mui-selected": {
              backgroundColor: "#F5F5F5",
            },
            "&:hover": {
              backgroundColor: "#F5F5F5",
            },
          }}
        >
          Español
        </MenuItem>
        <MenuItem
          onClick={() => handleLanguageChange("en")}
          selected={language === "en"}
          sx={{
            fontSize: "14px",
            minWidth: "120px",
            "&.Mui-selected": {
              backgroundColor: "#F5F5F5",
            },
            "&:hover": {
              backgroundColor: "#F5F5F5",
            },
          }}
        >
          English
        </MenuItem>
      </Menu>
    </Box>
  )
}

export default LanguageSwitcher

